import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import AllRoutes from './AllRoutes'
import Footer from './components/Footer'
import Sidebar from './components/Sidebar'

function App() {
  const { user } = useSelector((state) => state)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    document.title = 'Admin | Intra Africa Corporation'
    if (!user.userToken) {
      if (
        location?.pathname === '/forgot-password' ||
        location?.pathname?.includes('reset')
      ) {
        navigate(
          location?.search
            ? `${location?.pathname}${location?.search}`
            : location?.pathname
        )
      } else {
        navigate('/login')
      }
    } else {
      if (
        location.pathname === '/login' ||
        location.pathname === '/forgot-password' ||
        location.pathname?.includes('reset') ||
        location.pathname === '/'
      ) {
        navigate('/dashboard')
      } else {
        navigate(
          location?.search
            ? `${location?.pathname}${location?.search}`
            : location?.pathname
        )
      }
    }
  }, [user.userToken, location.pathname])

  return (
    <div className='page'>
      <div className='page-main'>
        {/* <Header /> */}
        {location?.pathname !== '/login' &&
        location?.pathname !== '/forgot-password' &&
        !location?.pathname?.includes('reset') ? (
          <Sidebar />
        ) : (
          <></>
        )}
        <div
          className={
            location?.pathname !== '/login' &&
            location?.pathname !== '/forgot-password' &&
            !location?.pathname?.includes('reset')
              ? 'main-content app-content'
              : ''
          }
        >
          <div className='wrraper-app'>
            <AllRoutes />
          </div>
        </div>
      </div>
      {location?.pathname !== '/login' &&
        location?.pathname !== '/forgot-password' &&
        !location?.pathname?.includes('reset') && <Footer />}
    </div>
  )
}

export default App
